import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { SwitchIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { useQuizList } from '../useQuizList';
export const QuizShuffleButton = () => {
  const {
    handleShuffle,
    quizList
  } = useQuizList();
  const {
    t
  } = useTranslation(['build']);
  const disabled = quizList.length < 2;
  return <Button variant="outlined" intent="neutral" size="sm" onClick={() => {
    handleShuffle();
    logger.track('build_shuffle_button_click');
  }} className="ml-auto flex" disabled={disabled} rounded="full" leftSlot={<SwitchIcon size="xs" fill={disabled ? ICON_COLOR.disabled : ICON_COLOR.default} />} data-sentry-element="Button" data-sentry-component="QuizShuffleButton" data-sentry-source-file="QuizShuffleButton.tsx">
      {t('build.quiz.shuffle')}
    </Button>;
};